// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#g_worldbn,
.em-worldrg,
.em-worldbn,
.em-worldbn-halo {
    stroke-linecap: round;
    stroke-linejoin: round;
}

.em-worldbn {
    stroke: #4d4d4d;
    stroke-width: 0.5px;
}

.em-worldbn,
.em-worldbn-halo {
    fill: none;
}

.em-worldrg {
    fill: #efefef;
    cursor: pointer;
}

.em-bn-d {
    /* disputed */
    stroke: #000;
    stroke-width: 0.1;
    opacity: 0.9;
    fill: none;
    stroke-dasharray: 1 1;
}

/* world boundary halo (not coastline) */
.em-worldbn-halo:not(.em-bn-co) {
    stroke: rgba(216, 216, 216, 0.3);
    stroke-width: 1px;
}
/* world boundary halo (not coastline, disputed) */
.em-worldbn-halo:not(.em-bn-co) .em-bn-d {
    stroke: rgba(141, 141, 141, 0.3);
    stroke-width: 1px;
    stroke-dasharray: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/css/world.css"],"names":[],"mappings":"AAAA;;;;IAII,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,qBAAqB;AACzB;;AAEA,wCAAwC;AACxC;IACI,gCAAgC;IAChC,iBAAiB;AACrB;AACA,kDAAkD;AAClD;IACI,gCAAgC;IAChC,iBAAiB;IACjB,qBAAqB;AACzB","sourcesContent":["#g_worldbn,\r\n.em-worldrg,\r\n.em-worldbn,\r\n.em-worldbn-halo {\r\n    stroke-linecap: round;\r\n    stroke-linejoin: round;\r\n}\r\n\r\n.em-worldbn {\r\n    stroke: #4d4d4d;\r\n    stroke-width: 0.5px;\r\n}\r\n\r\n.em-worldbn,\r\n.em-worldbn-halo {\r\n    fill: none;\r\n}\r\n\r\n.em-worldrg {\r\n    fill: #efefef;\r\n    cursor: pointer;\r\n}\r\n\r\n.em-bn-d {\r\n    /* disputed */\r\n    stroke: #000;\r\n    stroke-width: 0.1;\r\n    opacity: 0.9;\r\n    fill: none;\r\n    stroke-dasharray: 1 1;\r\n}\r\n\r\n/* world boundary halo (not coastline) */\r\n.em-worldbn-halo:not(.em-bn-co) {\r\n    stroke: rgba(216, 216, 216, 0.3);\r\n    stroke-width: 1px;\r\n}\r\n/* world boundary halo (not coastline, disputed) */\r\n.em-worldbn-halo:not(.em-bn-co) .em-bn-d {\r\n    stroke: rgba(141, 141, 141, 0.3);\r\n    stroke-width: 1px;\r\n    stroke-dasharray: 1 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
